import { Component, OnDestroy, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Refresher, Content, ModalController, PopoverController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { concatMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Subscription } from 'rxjs';
import { cloneDeep } from 'lodash';
import * as moment from 'moment';
import { _throw } from 'rxjs/observable/throw';


import { CoffeCategory } from '../../interfaces/CoffeCategory.interface';
import { ApiErrorHandlerProvider } from '../../providers/api-error-handler/api-error-handler';
import { CoffeService } from '../../interfaces/CoffeService.interface';
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';
import { TabsServiceProvider } from '../../providers/tabs-service/tabs-service';
import { CoffeShopServicePage } from '../coffe-shop-service/coffe-shop-service';
import { ServiceQuantityModal } from '../service-quantity-modal/service-quantity-modal';
import { CoffeShopEditPage } from '../coffe-shop-edit/coffe-shop-edit';
import { CoffeShopPaymentPage } from '../coffe-shop-payment/coffe-shop-payment';
import { DurationPipe } from '../../pipes/duration/duration';
import { ProfileLoginPage } from '../profile-login/profile-login';


@IonicPage()
@Component({
  selector: 'page-coffe-shop',
  templateUrl: 'coffe-shop.html',
  providers: []
})
export class CoffeShopPage implements OnDestroy {
  @ViewChild(Refresher) refresher: Refresher;
  @ViewChild(Content) content: Content;
  private subscription$: Subscription;
  private promo_products: PromoProducts = null;

  public poromoProductCount: number = 0;

  public shopTab: 'menu' | 'about' | 'trending' | 'locations' = 'menu';
  public errorMessage: string = '';

  public loading: boolean = false;
  public refreshing: boolean = false;
  public timeLoading: boolean = false;
  public showCoffeShop: boolean = false;
  public enableShopPromoProducts: boolean = false;
  private disabledAdvancedBooking: boolean = false;
  public showLocation: boolean = false;
  public disableContinueButton: boolean = false;
  public random : any = 0;

  constructor(
    public statusBar: StatusBar,
    public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    private popoverCtrl: PopoverController,
    public coffeShopService: CoffeShopService,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private tabsService: TabsServiceProvider,
    public durationPipe: DurationPipe) {
  }

  ionViewWillEnter() {
    this.statusBar.overlaysWebView(true);
    this.loading = true;
    if (this.coffeShopService.categories.length) {
      this.coffeShopService.clearDates();
      this.getFirstBookingDate();
      this.getLastBookingDate();
      this.promo_products ? this.enableShopPromoProducts = !!localStorage.getItem('tuid') && !!this.promo_products.promo_product_limit : null;
      this.loading = false;
    } else {
      this.initialData(false);
    }
    if (this.coffeShopService.totalOrders && !this.loading && this.shopTab === 'menu') {
      this.tabsService.hide();
    }
  }

  private initialData(refresh: boolean): void {
    const coffeShopId = this.navParams.get('shopId');
    this.subscription$ = forkJoin([
      this.coffeShopService.getCoffeShop(coffeShopId),
      this.coffeShopService.getStaffHolidays(coffeShopId)
    ]).pipe(switchMap(([shop, holidays]: any) => {
      if (shop.users) {
        shop.users.forEach((user, index) => {
          shop.users[index].holidays = [];
          if (holidays[user.id]) {
            shop.users[index].holidays = holidays[user.id];
          }
        });
        shop.all_staff = shop.users;
        shop = this.coffeShopService.filterAvailableUsers(shop);
      }
      this.coffeShopService.coffeShop = shop;
      this.coffeShopService.currencySymbol = this.coffeShopService.coffeShop.timezone.currency_symbol;
      this.setShowCoffeShop(this.coffeShopService.coffeShop.has_active_barbers);
      this.proccessShop(shop);
      if (localStorage.getItem('tuid')) {
        return forkJoin([
          this.coffeShopService.getCategoriesWithServices(this.coffeShopService.coffeShop.id, this.coffeShopService.coffeShop.owner_id, +localStorage.getItem('tuid')),
          this.coffeShopService.getPromoLimits(shop.id),
          this.coffeShopService.getShopLocation(shop.owner_id)
        ])
      } else {
        return forkJoin([
          this.coffeShopService.getCategoriesWithServices(this.coffeShopService.coffeShop.id, this.coffeShopService.coffeShop.owner_id, +localStorage.getItem('tuid')),
          of(null),
          this.coffeShopService.getShopLocation(shop.owner_id),
        ])
      }
    })).subscribe(([categories, promo_products, locations]: [CoffeCategory[], PromoProducts, any[]]) => {
      this.setLocations(locations);
      this.setPromo(promo_products);
      categories = categories.map((category: CoffeCategory) => {
        category.services = category.services.filter((service: CoffeService) => service.promo_product !== 1 || (service.promo_product === 1 && this.enableShopPromoProducts));
        return category;
      });
      categories = categories.filter((category: CoffeCategory) => category.services.length);
      categories = this.appendFieldToService(categories);
      this.coffeShopService.categories = categories.slice();
      this.loading = false;
      if (refresh) {
        this.refreshing = false;
        this.refresher.complete();
      }
    }, ((error: HttpErrorResponse) => {
      if (refresh) {
        this.refreshing = false;
        this.refresher.complete();
      }
      this.loading = false;
      this.navCtrl.pop();
      this.apiErrorHandler.handleError({ error })
    }));
  }
  private setPromo(promo_products: PromoProducts): void {
    if (promo_products) {
      this.promo_products = promo_products;
      this.calculatePromoProductsCount();
    } else {
      this.promo_products = null;
      this.poromoProductCount = 0;
    }
    this.promo_products ? this.enableShopPromoProducts = !!localStorage.getItem('tuid') && !!this.promo_products.promo_product_limit : null;
  }
  public pullToRefresh(event): void {
    this.refreshing = true;
    this.clearLocalData();
    this.coffeShopService.clearDates();
    this.coffeShopService.clearServiceData(false);
    this.initialData(true);
  }
  public segmentChanged($event): void {
    if (this.shopTab !== 'menu') {
      this.tabsService.show();
      return;
    }
    if (this.shopTab === 'menu' && this.coffeShopService.totalOrders === 0) {
      this.tabsService.show();
      return;
    }
    if (this.shopTab === 'menu' && this.coffeShopService.totalOrders !== 0) {
      this.tabsService.hide();
      return;
    }
  }
  public makeAdvanceBookingEvent(event: 'coffeShop' | 'barberShop') {
    if (event === 'coffeShop') {
      this.shopTab = 'menu';
      this.setShowCoffeShop(true);
    }
  }
  public selectUserEvent(event: 'coffeShop' | 'barberShop') {
    if (event === 'coffeShop') {
      this.shopTab = 'menu';
      this.setShowCoffeShop(true);
    }
  }
  public dateIsEqual(date1: Date, date2: Date): boolean {
    date1 = new Date(date1); date2 = new Date(date2);
    return date1.getTime() === date2.getTime();
  }
  public selectHoursEvent(event) {
    this.shopTab = 'menu';
    this.loading = true;
    this.setShowCoffeShop(true);
    const date = this.coffeShopService.getBookingDate(event.data.day.name);
    const newDate = new Date(+date.split('/')[2], +date.split('/')[1] - 1, +date.split('/')[0], 0, 0, 0);
    this.coffeShopService.showChooseDate = true;
    this.timeLoading = true;
    this.coffeShopService.advancedBookingRequest({ date: date, available: true }, false)
      .pipe(switchMap((barbers) => {
        this.proccessAdanceBookingRequest({ date: date, available: true }, barbers, null);
        this.openCalendar();
        let selectedDate = this.coffeShopService.bookingDates.find((date) => {
          return newDate.getTime() === (date.date as any).getTime() && date.available;
        });
        !selectedDate ? selectedDate = this.coffeShopService.bookingDates.find((date) => {
          if (date.available) {
            const bookingDate = new Date((date.date as any).getDate(), (date.date as any).getMonth(), (date.date as any).getFullYear());
            const today = new Date(new Date().setHours(0, 0, 0, 0));
            return today.getTime() === bookingDate.getTime();
          }
        }) : null;
        if(typeof(this.coffeShopService.bookingDates) != "undefined" && this.coffeShopService.bookingDates.length > 0){

          !selectedDate && this.coffeShopService.bookingDates[0].available ? selectedDate = this.coffeShopService.bookingDates[0] : null;
        }
        if (!selectedDate) {
          this.coffeShopService.clearDates();
          return _throw(new Error('Coffe Shop doesnt have free barmans or free time.'))
        } else {
          const requestDate = moment(selectedDate.date).format('DD/MM/YYYY');
          return forkJoin([of(barbers), this.coffeShopService.getAvailableBookingTimes(requestDate, barbers[0]), of(selectedDate.date)]);
        }
      })).subscribe(([barbers, times, selectedDate]) => {
        this.coffeShopService.selectedDate = selectedDate as any;
        this.proccessAdanceBookingRequest({ date: selectedDate, available: true }, barbers, times);
        if (this.coffeShopService.coffeShop.has_active_barbers) {
          this.checkBarberIsFree();
        }
        this.timeLoading = false;
        this.loading = false;
        setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
      }, (error: HttpErrorResponse) => {
        this.errorMessage = error.message;
        this.timeLoading = false;
        this.loading = false;
        setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
      });

  }
  private setLocations(locations: any[]): void {
    locations = locations.filter((location) => location.settings
      && location.settings.shop_type === this.coffeShopService.coffeShop.settings.shop_type
      && location.id !== this.coffeShopService.coffeShop.id);
    this.showLocation = !!locations.length;
  }
  private setShowCoffeShop(value): void {
    this.showCoffeShop = value;
  }
  public async chooseDateAndTime(): Promise<void> {
    this.coffeShopService.showChooseDate = true;
    this.timeLoading = true;
    setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
    this.coffeShopService.getCoffeShop(this.coffeShopService.coffeShop.id)
      .pipe(switchMap((shop: any) => {
        this.proccessShop(shop);
        this.coffeShopService.user.advanced_booking_hours === null ? this.disabledAdvancedBooking = true : this.disabledAdvancedBooking = false;
        if (this.coffeShopService.user.advanced_booking_hours) {
          return this.coffeShopService.advancedBookingRequest({ date: '', available: true }, true)
            .pipe(switchMap((barbers) => {
              this.proccessAdanceBookingRequest({ date: '', available: true }, barbers, null);
              this.openCalendar();
              this.random = Math.floor(Math.random() * barbers.length);
              if (this.coffeShopService.bookingDates.length) {
                this.coffeShopService.selectedDate = this.coffeShopService.bookingDates.find((date) => date.available).date as any;
                const formattedDate = this.coffeShopService.requestDateFormatter(this.coffeShopService.selectedDate);
                setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
                return forkJoin([of(barbers), this.coffeShopService.getAvailableBookingTimes(formattedDate, barbers[this.random])])
                //   return _throw(new Error('Queue is full'));
              } else {
                setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
                return forkJoin([of(barbers), of(null)])
              }

            }))
        } else {
          return of(shop);
        }
      })).subscribe(([barbers, times]: any) => { //[barbers, times]: any
        if (this.coffeShopService.bookingDates.length && barbers && times) {
          this.proccessAdanceBookingRequest(this.coffeShopService.bookingDates[0], barbers, times);
        }
        if (this.coffeShopService.coffeShop.has_active_barbers) {
          this.checkBarberIsFree();
        }
        this.timeLoading = false;
        setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
      }, (error: HttpErrorResponse) => {
        this.errorMessage = error.message;
        this.timeLoading = false;
        setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
      });
  }
  private proccessShop(shop): void {
    this.coffeShopService.shop = shop;
    this.coffeShopService.user = shop.users[0];
    this.getFirstBookingDate();
    this.getLastBookingDate();
  }
  private appendFieldToService(categories: CoffeCategory[]): CoffeCategory[] {
    return categories.map((category) => {
      category.services = category.services.map((service) => {
        service.calculated_price = service.price;
        service.quantity = 0;
        service.special_instructions = '';
        service.children.length ? service.children = service.children.map((children) => {
          children.calculated_price = 0;
          service.special_instructions = '';

          children.quantity = 0;
          return children;
        }) : null;
        return service;
      })
      return category;
    })
  }
  private handlePageState(): void {
    if (this.coffeShopService.totalOrders > 0) {
      this.tabsService.hide();
    } else {
      this.tabsService.show();
    }

  }
  public cardClicked(service: CoffeService, categoryName: string): void {
    if (!localStorage.getItem('tuid')) {
      this.navCtrl.push(ProfileLoginPage, {
        shop: this.coffeShopService.coffeShop
      });
      return;
    }
    let modal = null;
    if (!service.children.length) {
      modal = this.popoverCtrl.create(ServiceQuantityModal, {
        service,
        selectedServicesCount: service.quantity || 0,
        selectedServicesDuration: service.duration,
        availableServiceDuration: null,
        currencySymbol: this.coffeShopService.currencySymbol,
        numMaxServicesForBooking: service.stock,
        byStaff: false,
        shopType: 'coffe'
      }, { enableBackdropDismiss: false });
    } else {
      if (service.stock !== null && service.quantity >= service.stock) {
        this.coffeShopService.presentAlert('',
          `Only ${service.stock} items of ${service.name} are available to order`,
          true, [{ text: 'Ok' }]);
        return;
      }
      modal = this.modalCtrl.create(CoffeShopServicePage, { service, categoryName });
    }
    modal.present();
    modal.onWillDismiss((resp: { service: CoffeService }) => {
      if (resp) {
        if (resp.service.quantity === 0) {
          const serviceIndex = this.coffeShopService.selectedServices.findIndex((service: CoffeService) => service.id === resp.service.id);
          this.coffeShopService.selectedServices.splice(serviceIndex, 1);
        }
        const doppings: CoffeService[] = cloneDeep(resp.service.doppings);
        if (doppings) {
          resp.service.calculated_price = resp.service.price;
          resp.service.quantity = 1;
        }
        const service = cloneDeep(doppings ? this.calculateTotalServicePrice(resp.service) : resp.service);
        this.updateCategoryService(service, doppings);
        this.calculateTotalOrders(this.coffeShopService.categories);
        this.handlePageState();
      } else {
        if (!this.coffeShopService.selectedServices.length) {
          this.tabsService.show();
        }
      }
      this.calculatePromoProductsCount();
    });
  }
  public async openEditModal(service: CoffeService): Promise<void> {
    if (!this.coffeShopService.selectedServices.length || !service.children.length) { return; }
    const services = cloneDeep(this.coffeShopService.selectedServices.filter((selectedService: CoffeService) => service.id === selectedService.id));
    const modal = this.modalCtrl.create(CoffeShopEditPage, { services }, { enableBackdropDismiss: true });
    await modal.present();
    modal.onWillDismiss((resp: { services: CoffeService[], cached: CoffeService[] }) => {
      if (resp && resp.services) {
        if (resp.services.length) {
          const resp_services = cloneDeep(resp.services);
          const servicesIndexes: any = resp_services.map((service: CoffeService) => service.id);
          this.coffeShopService.selectedServices = this.coffeShopService.selectedServices.filter((service: CoffeService) => !servicesIndexes.includes(service.id));

          resp_services.forEach((service: CoffeService) => {
            service.calculated_price = service.price;
            service.quantity = 1;
            service = this.calculateTotalServicePrice(service);
            this.updateCategoryService(service, service.doppings);
          });
          this.calculateTotalOrders(this.coffeShopService.categories);
          this.handlePageState();
        } else {
          const servicesIndexes: any = resp.cached.map((service) => service.id);
          servicesIndexes.forEach((id: number) => {
            const serviceIndex = this.coffeShopService.selectedServices.findIndex((service: CoffeService) => service.id === id);
            this.coffeShopService.selectedServices.splice(serviceIndex, 1);
          });
          this.coffeShopService.categories = this.coffeShopService.categories.map((category: CoffeCategory) => {
            servicesIndexes.forEach((id: number) => {
              const serviceIndex = category.services.findIndex((service: CoffeService) => service.id === id);
              if (serviceIndex >= 0) {
                category.services[serviceIndex].doppings = [];
                category.services[serviceIndex].calculated_price = category.services[serviceIndex].price;
                category.services[serviceIndex].quantity = category.services[serviceIndex].quantity - 1;
              }
            });
            return category;
          });
          this.calculateTotalOrders(this.coffeShopService.categories);
          this.handlePageState();
        }
      }
      this.calculatePromoProductsCount();
    });

  }
  private updateCategoryService(updatedService: CoffeService, doppings: CoffeService[]) {
    const categoryIndex = this.coffeShopService.categories.findIndex((category) => category.id === updatedService.team_category_id);
    const serviceIndex = updatedService ? this.coffeShopService.categories[categoryIndex].services.findIndex((service) => service.id === updatedService.id) : null;
    if (serviceIndex < 0) { return; }
    if (!doppings) {
      this.coffeShopService.categories[categoryIndex].services[serviceIndex] = updatedService;
      if (updatedService.quantity) {
        this.coffeShopService.categories[categoryIndex].services[serviceIndex].calculated_price = this.coffeShopService.categories[categoryIndex].services[serviceIndex].price * this.coffeShopService.categories[categoryIndex].services[serviceIndex].quantity;
      } else {
        this.coffeShopService.categories[categoryIndex].services[serviceIndex].calculated_price = this.coffeShopService.categories[categoryIndex].services[serviceIndex].price;
      }
      const selected_ids: any = this.coffeShopService.selectedServices.map(service => service.id);
      if (selected_ids.includes(this.coffeShopService.categories[categoryIndex].services[serviceIndex].id)) {
        const index = this.coffeShopService.selectedServices.findIndex((service) => service.id === this.coffeShopService.categories[categoryIndex].services[serviceIndex].id);
        this.coffeShopService.selectedServices[index] = this.coffeShopService.categories[categoryIndex].services[serviceIndex];
      } else {
        if (this.coffeShopService.categories[categoryIndex].services[serviceIndex].quantity > 0) {
          this.coffeShopService.selectedServices.push(this.coffeShopService.categories[categoryIndex].services[serviceIndex]);
        }
      }
    } else {
      this.coffeShopService.selectedServices.push(updatedService);
      this.coffeShopService.categories[categoryIndex].services[serviceIndex].calculated_price = 0;
      this.coffeShopService.categories[categoryIndex].services[serviceIndex].quantity = 0;
      this.coffeShopService.selectedServices.forEach((service) => {
        if (service.id === this.coffeShopService.categories[categoryIndex].services[serviceIndex].id) {
          this.coffeShopService.categories[categoryIndex].services[serviceIndex].calculated_price += service.calculated_price;
          this.coffeShopService.categories[categoryIndex].services[serviceIndex].quantity += 1;
        }
      });
    }
  }
  private calculateTotalOrders(categories: CoffeCategory[]) {
    this.coffeShopService.totalOrders = 0;
    categories.forEach((category: CoffeCategory) => {
      category.services.forEach((service: CoffeService) => {
        if (service.quantity) {
          this.coffeShopService.totalOrders = this.coffeShopService.totalOrders + service.quantity;
        }
      });
    });
  }
  private calculateTotalServicePrice(service): CoffeService {
    service.doppings.length ? service.doppings.forEach((dopping) => service.calculated_price += dopping.quantity * dopping.price) : null;
    return service;
  }
  public goToPayment() {
    if (this.coffeShopService.coffeShop.settings.max_order_quantity !== null && this.coffeShopService.totalOrders > this.coffeShopService.coffeShop.settings.max_order_quantity) {
      this.coffeShopService.presentAlert('',
        `Only ${this.coffeShopService.coffeShop.settings.max_order_quantity} products are available to order`,
        true, [{ text: 'Ok' }]);
      return;
    }

    if (!this.coffeShopService.selectedDate || !this.coffeShopService.selectedTime) { //this.coffeShopService.user.advanced_booking_hours && (!this.coffeShopService.selectedDate || !this.coffeShopService.selectedTime)
      this.chooseDateAndTime();
      return;
    }
    this.coffeShopService.showChooseDate = false;
    const services: CoffeService[] = [].concat.apply([], this.coffeShopService.categories.map((category: CoffeCategory) => category.services.map((service: CoffeService) => {
      if (service.quantity > 0) { return service; }
    }))).filter((service: CoffeService) => !!service);
    this.navCtrl.push(CoffeShopPaymentPage, { services,selectedBarber : this.random });
  }
  private calculatePromoProductsCount(): void {
    const count = this.coffeShopService.selectedServices
      .filter((service: CoffeService) => service.quantity && service.promo_product)
      .reduce((accumulator, currentValue) => accumulator + currentValue.quantity, 0);
    this.poromoProductCount = this.promo_products.promo_product_limit - this.promo_products.promo_product_count - count;
  }
  getLastBookingDate() {
    let daysBookingCanBeMadeInAdvance = this.coffeShopService.shop.settings ? this.coffeShopService.shop.settings.num_days_bookings_can_be_made_in_advance : 7;
    this.coffeShopService.lastBookingDate = moment().add(daysBookingCanBeMadeInAdvance, 'days');
    this.coffeShopService.lastBookingDate = new Date(this.coffeShopService.lastBookingDate.get('year'), this.coffeShopService.lastBookingDate.get('month'), this.coffeShopService.lastBookingDate.get('date'));
  }
  getFirstBookingDate() {
    let date = moment(this.coffeShopService.shop.first_advanced_booking_date, 'YYYY-MM-DD');
    this.coffeShopService.firstBookingDate = new Date(date.get('year'), date.get('month'), date.get('date'));
  }
  isWorkingDay(barberData, date) {
    const weekday = date.getDay();
    if (!barberData.enabledWeekdays.find(i => i === weekday)) {
      return false;
    }

    return !barberData.holidays.find(i => i.getTime() === date.getTime())
  }
  openCalendar() {
    let disableWeeks = [0, 1, 2, 3, 4, 5, 6];
    let enabledDays: any = [];
    const barbersData = [];
    const allHolidays = [];

    // Combine the enabled days and holidays of multiple barbers
    this.coffeShopService.allBarbers.forEach(barber => {
      let holidays = this.coffeShopService.daysConfig(barber);
      let enabledDaysInAWeek = this.coffeShopService.enabledDaysInAWeek(barber);

      barbersData.push({
        holidays: holidays.map(i => i.date),
        enabledWeekdays: enabledDaysInAWeek,
      });
      for (const h of holidays) {
        if (!allHolidays.find(i => i.date.getTime() === h.date.getTime())) {
          allHolidays.push(h);
        }
      }

      enabledDaysInAWeek.forEach((day, index) => {
        enabledDays.push(day);
      });
    });

    const allTeamHolidays = [];
    for (const h of allHolidays) {
      const anyBarberAvailable = barbersData.find(i => this.isWorkingDay(i, h.date));
      if (!anyBarberAvailable) allTeamHolidays.push(h)
    }

    let options = this.coffeShopService.options();

    // Remove enabled days from the days to disable in the calendar
    enabledDays.forEach((day) => {
      // @ts-ignore
      if (disableWeeks.includes(day)) {
        let index = disableWeeks.indexOf(day);
        if (index !== -1) disableWeeks.splice(index, 1);
      }
    });
    const lastday: Date = options.to;
    let today: Date = options.from;
    const dates = [];
    while (today.getTime() <= lastday.getTime()) {
      const available = enabledDays.includes(today.getDay());
      dates.push({ date: today, available });
      today = new Date(today.getTime() + 86400000)
    }
    this.coffeShopService.bookingDates = dates.filter((date) => date.available);
  }
  public selectTime(bookingTime: BookingTimes): void {
    if (!bookingTime.available || bookingTime.date === this.coffeShopService.selectedTime) { return; }
    this.coffeShopService.bookingType = bookingTime.booking_type ? bookingTime.booking_type : null;
    bookingTime.date === this.coffeShopService.selectedTime ? this.coffeShopService.selectedTime = '' : this.coffeShopService.selectedTime = bookingTime.date;
  }
  filterBarbersByAvailability(booking: { date: string, available: boolean }): Promise<boolean | HttpErrorResponse> {
    if (booking.available === false || this.disabledAdvancedBooking || this.timeLoading || this.dateIsEqual((this.coffeShopService.selectedDate as any), (booking.date as any))) {
      return;
    }
    if (booking.date === this.coffeShopService.selectedDate && booking.date !== '') {
      this.coffeShopService.selectedDate = '';
      this.coffeShopService.selectedTime = '';
      return;
    }
    if (booking.date) {
      this.timeLoading = true;
      this.coffeShopService.selectedDate = booking.date;
      this.coffeShopService.bookingTimes = [];
      this.coffeShopService.selectedTime = '';
      this.errorMessage = '';
    }

    const formattedDate = booking.date ? this.coffeShopService.requestDateFormatter(booking.date) : booking.date;
    this.coffeShopService.advancedBookingRequest(booking, true)
      .pipe(concatMap((barbers: any) => {
        if (booking.date !== '') {
          return forkJoin([of(barbers), this.coffeShopService.getAvailableBookingTimes(formattedDate, barbers[0])])
        } else {
          return forkJoin([of(barbers), of(null)])
        }
      }))
      .subscribe(([barbers, times]: any) => {
        this.coffeShopService.bookingType = null;
        this.proccessAdanceBookingRequest(booking, barbers, times);
        if ((booking.date as any).getTime() === new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime()
          && this.coffeShopService.coffeShop.has_active_barbers) {
          this.checkBarberIsFree();
        }
        this.timeLoading = false;
      }, (error: HttpErrorResponse) => {
        this.timeLoading = false;
        this.errorMessage = error && error.message ? error.message : 'Not available time for this day.';
      });
  }

  private proccessAdanceBookingRequest(booking, barbers, times) {
    if (times && times.length) {
      times = times.filter((timeObj) => timeObj.available).map(timeObj => {
        timeObj.date = moment(timeObj.date).format('HH:mm');
        return timeObj;
      })
      this.coffeShopService.bookingTimes = times;
      this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes.some((time) => time.available) ? this.coffeShopService.bookingTimes.find((timeObject) => timeObject.available === true).date : '';
    }
    if (barbers) {
      this.coffeShopService.barbers = barbers;
    }
    if (!this.coffeShopService.allBarbers || !booking.date) {
      this.coffeShopService.allBarbers = barbers;
    }
  }
  public checkBarberIsFree(): void {
    const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
    const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));
    const today_time = `${timezoen.getHours() >= 10 ? timezoen.getHours() : `0` + timezoen.getHours()}:${timezoen.getMinutes() >= 10 ? timezoen.getMinutes() : `0` + timezoen.getMinutes()}`
    const today_day = moment(timezoen).format('dddd').toLocaleLowerCase();
    const barmen_time_end = this.coffeShopService.user.hours[`${today_day}`] ?
      `${this.coffeShopService.user.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.user.hours[`${today_day}`].split(':')[1]}` : null;
    const barmen_has_andvanced_booking = !!this.coffeShopService.user.advanced_booking_hours;
    if (!barmen_has_andvanced_booking && !barmen_time_end && !this.coffeShopService.coffeShop.hours[`${today_day}`]) {
      this.disableContinueButton = true;
      this.errorMessage = 'Queue is full';
      return;
    }
    let time = null;
    if (this.coffeShopService.user && this.coffeShopService.user.current_queue_length > 0) {
      this.coffeShopService.user.current_chair_time_with_cancelled = this.coffeShopService.user.current_chair_time_with_cancelled.toUpperCase();
      time = this.coffeShopService.user.current_chair_time_with_cancelled.includes('AM') ?
        this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('AM').join(' AM')) :
        this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('PM').join(' PM'));
    } else if (this.coffeShopService.user && this.coffeShopService.user.current_queue_length <= 0) {
      if (barmen_time_end) {
        if (today_time < barmen_time_end) {
          time = today_time
        } else {
          this.disableContinueButton = true;
          this.errorMessage = 'Queue is full';
          return;
        }
      }
      if (!barmen_time_end && this.coffeShopService.coffeShop.hours[`${today_day}`]) {
        const shop_hours_start = `${this.coffeShopService.coffeShop.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.coffeShop.hours[`${today_day}`].split(':')[1]}`;
        const shop_hours_end = `${this.coffeShopService.coffeShop.hours[`${today_day}_close`].split(':')[0]}:${this.coffeShopService.coffeShop.hours[`${today_day}_close`].split(':')[1]}`;
        if (today_time < shop_hours_start) { time = shop_hours_start; }
        if (today_time > shop_hours_start && today_time < shop_hours_end) { time = today_time; }
        if (today_time > shop_hours_end) {
          this.disableContinueButton = true;
          this.errorMessage = 'Queue is full';
          return;
        }
      }
    }
    if (time) {
      if (this.coffeShopService.user.advanced_booking_hours && this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) {
        if (this.coffeShopService.bookingTimes.length && this.coffeShopService.bookingTimes[0].date === time) {
          this.coffeShopService.bookingTimes[0].booking_type = 1;
        } else {
          this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
        }
        this.coffeShopService.selectedTime = time;
        this.coffeShopService.bookingType = 1;
        if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
          this.coffeShopService.bookingDates.unshift({ date: now, available: true });
          this.coffeShopService.selectedDate = now as any;
        }
        return;
      }
      if (((!this.coffeShopService.user.advanced_booking_hours || !this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) && this.coffeShopService.user.hours[`${today_day}_start`])
        || this.coffeShopService.coffeShop.hours[`${today_day}`]) {
        this.coffeShopService.bookingTimes = [];
        this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
        this.coffeShopService.selectedTime = time;
        this.coffeShopService.bookingType = 1;
        if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
          this.coffeShopService.bookingDates.unshift({ date: now, available: true });
          this.coffeShopService.selectedDate = now as any;
        }
      }
    }
  }
  public goBack() {
    this.tabsService.show();
    this.navCtrl.pop();
  }
  private clearLocalData(): void {
    this.subscription$.unsubscribe();
    this.errorMessage = '';
    this.timeLoading = false;
    this.enableShopPromoProducts = false;
    this.disabledAdvancedBooking = false;
    this.disableContinueButton = false;
  }
  ionViewWillLeave() {
    this.statusBar.overlaysWebView(false);
  }
  ionViewDidLeave(): void {
    this.statusBar.overlaysWebView(false);
    if (this.subscription$) { this.subscription$.unsubscribe(); }
  }
  ngOnDestroy() {
    this.coffeShopService.clearServiceData(true);
    this.coffeShopService.clearDates();
  }
}
interface BookingTimes {
  date: string;
  available: boolean;
  booking_type?: number;
}
interface PromoProducts {
  promo_product_count: number;
  promo_product_limit: number;
}


// WEBPACK FOOTER //
// ./src/pages/coffe-shop/coffe-shop.ts